import customerGroup from '@mui/icons-material/WorkOutlineOutlined';
import customer from '@mui/icons-material/GroupsOutlined';
import organisation from '@mui/icons-material/CorporateFareOutlined';
import orderer from '@mui/icons-material/BadgeOutlined';
import ordererPermission from '@mui/icons-material/AdminPanelSettingsOutlined';
import form from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import input from '@mui/icons-material/InputOutlined';
import repeatTimer from '@mui/icons-material/ManageHistoryOutlined';
import rocketLaunched from '@mui/icons-material/RocketLaunchOutlined';

import layout from '@mui/icons-material/BackupTableOutlined';
import view from '@mui/icons-material/TableRowsOutlined';
import section from '@mui/icons-material/ViewDayOutlined';
import modal from '@mui/icons-material/FlipToFrontOutlined';
import drawer from '@mui/icons-material/ChromeReaderModeOutlined';
import main from '@mui/icons-material/AccountTreeOutlined';
import pricelist from '@mui/icons-material/PriceChangeOutlined';
import preview from '@mui/icons-material/WysiwygOutlined';
import code from '@mui/icons-material/CodeOutlined';
import json from '@mui/icons-material/DataObjectOutlined';
import displayData from '@mui/icons-material/ContentPasteSearchOutlined';
import format from '@mui/icons-material/FormatAlignJustifyOutlined';
import diff from '@mui/icons-material/CompareArrowsOutlined';
import reset from '@mui/icons-material/RestartAltOutlined';
import fullscreen from '@mui/icons-material/Fullscreen';
import keepChanges from '@mui/icons-material/PublishedWithChangesOutlined';
import formData from '@mui/icons-material/Dataset';
import bug from '@mui/icons-material/BugReportOutlined';
import alternateEmailOutlined from '@mui/icons-material/AlternateEmailOutlined';

export {
  customerGroup,
  customer,
  organisation,
  orderer,
  ordererPermission,
  form,
  input,
  repeatTimer,
  rocketLaunched,
  layout,
  view,
  section,
  modal,
  drawer,
  main,
  pricelist,
  preview,
  code,
  json,
  displayData,
  format,
  diff,
  reset,
  fullscreen,
  keepChanges,
  formData,
  bug,
  alternateEmailOutlined
};
